import React, { Component } from 'react';
import FormBuilderItem from './formItensElements/FormBuilderItem';

class FormItens extends Component {
    constructor(props){
        super(props);
        this.verificaBoleto = this.verificaBoleto.bind(this);
    }
    
    verificaBoleto(){
        if(this.props.dataLimiteBoleto === undefined){
            return false;
        }else{
            return this.props.dataLimiteBoleto
        }
    }

    getClassNameUpCampo(item){
        let opcoesForm = []
        for(let i = 0; i <= (this.verificaBoleto() ? 8 : 3); i++){
            opcoesForm.push(i)
        }
        const opcoesGRU = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
        if(this.props.tipoForm === 'form'){ //Formulário
            return (opcoesForm.indexOf(this.props.itens.indexOf(item)) >= 0 ? true : false);
        }else{ //GRU
            return (opcoesGRU.indexOf(this.props.itens.indexOf(item)) >= 0 ? true : false);
        }
    }

    getClassNameDonwCampo(item){
        let opcoesForm = []
        for(let i = 0; i <= (this.verificaBoleto() ? 7 : 2); i++){
            opcoesForm.push(i)
        }
        opcoesForm.push(this.props.itens.length - 1)
        const opcoesGRU = [this.props.itens.length - 1, 0, 1, 2, 3, 4, 5, 6, 7, 8]
        if(this.props.tipoForm === 'form'){ //Formulário
            return (opcoesForm.indexOf(this.props.itens.indexOf(item)) >= 0 ? true : false);
        }else{ //GRU
            return (opcoesGRU.indexOf(this.props.itens.indexOf(item)) >= 0 ? true : false);
        }
    }
    
    render() {
        return (
            <div className="width-100">
                {this.props.itens.map(item => (
                    <FormBuilderItem
                        key={item.id}
                        itemId={item.id}
                        ordem={(this.props.itens.indexOf(item)+1).toString()}
                        item={item}
                        actions={this.props.actions}
                        lastCard={this.props.itens.indexOf(item) === this.props.itens.length - 1 ? true : false}
                        temBoleto={this.verificaBoleto()}
                        tipoForm={this.props.tipoForm}
                        evento={this.props.evento}
                        upCampo={this.props.actions.upCampo.bind(this)}
                        disabledUpCampo={this.getClassNameUpCampo(item)}
                        downCampo={this.props.actions.downCampo.bind(this)}
                        disabledDownCampo={this.getClassNameDonwCampo(item)}
                    />
                ))}
            </div>
        );
    }
}

export default FormItens;


// WEBPACK FOOTER //
// ./src/components/formbuilder/FormItens.js